<template lang="pug">
.arrow-btn-blue
  .copy {{ copy }}
  .arrow
    arrow-blue
  
</template>
<script>
import ArrowGray from '@/components/wedgits/ArrowGray'
import { mapMutations } from 'vuex'
import ArrowBlue from '@/components/wedgits/ArrowBlue'
export default {
  name: 'ArrowBtnBlue',
  components: { ArrowBlue, ArrowGray },
  props: {
    copy: {},
    // to: {},
    // from: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.arrow-btn-blue
  display: flex
  align-items: center
  .copy
    font-size: pxToRem(30)
    color: $cl-blue
    line-height: 0
  .arrow
    width: pxToRem(36)
    height: pxToRem(36)
</style>
